
import * as ACTIONS from '../constants';

export function getAllInfodexes() {
  return {
    type: ACTIONS.INFODEX_ALL_GET
  }
};
export function getAllCryodex(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_GET, payload };
}

export function getCryodexInfodexLink(payload){
  return { type: ACTIONS.CRYODEX_INFODEX_LINK_GET, payload };
}

export function updateInfodexCryodexLink(payload){
  return { type: ACTIONS.CRYODEX_CRYODEX_INFODEX_LINK_UPDATE, payload };
}
export function deleteCryodexGroupMember(payload){
  return { type: ACTIONS.CRYODEX_CRYODEX_GROUPS_MEMBER_DELETE, payload };
}

export function deleteCryodexGroup(payload){
  return { type: ACTIONS.CRYODEX_USER_GROUPS_DELETE, payload };
}

export function renameCryodexGroup(payload){
  return { type: ACTIONS.CRYODEX_USER_GROUPS_RENAME, payload };
}


export function deleteInfodexGroup(payload){
 
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_DELETE, payload };
}

export function renameInfodexGroup(payload){
  
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_RENAME, payload };
}


export function updateLinkedInfodex(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_LINKED_UPDATE, payload };
}

export function updateUserInformation(payload) {
  return { type: ACTIONS.CRYODEX_UPDATE_USER, payload };
}


export function getInfodexLinked(payload){
  return { type: ACTIONS.CRYODEX_INFODEX_LINKED_GET ,payload};  
}

export const getUserInformationAction = () => {

  return {
      type: ACTIONS.CRYODEX_CRYODEX_CURRENT_GET
  }
};

export function getCryodexLinks(){
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKS_GET };  
}

export function updateCryodexLinks(payload){
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKS_UPDATE, payload };  
}

export function updateGetUserInformation(payload) {
  return { type: ACTIONS.CRYODEX_GET_USER, payload };
}

export function getInfodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_GET, payload };
}


export function updateInfodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_UPDATE, payload };
}

export function createInfodexGroup(payload) {
  return { type: ACTIONS.CRYODEX_INFODEX_GROUPS_CREATE, payload };
}

export function getCryodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_GET, payload };
}

export function getAllCryodexes(payload) {
  return { type: ACTIONS.CRYODEX_CRYODEX_ALL_GET, payload };
}

export function getAllAssociatedCryodexes(payload) {
  return { type: "", payload };
}

export function updateAllCryodex(payload) {
  return { type: ACTIONS.CRYODEX_CRYODEX_UPDATE, payload };
}

export function updateCryodexGroups(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_UPDATE, payload };
}

export function createCryodexGroup(payload) {
  return { type: ACTIONS.CRYODEX_USER_GROUPS_CREATE, payload };
}

export function getIsolatedCryodex(payload) {
  return {
    type: ACTIONS.CRYODEC_GET_ISOLATED_CRYODEX,
    payload
  }
}

export function updateIsolatedCryodex(payload) {
  return {
    type: ACTIONS.CRYODEX_UPDATE_ISOLATED_CRYODEX,
    payload
  }
}

// Send invite
export function sendInvite(payload) {
  
  return {type: ACTIONS.CRYODEX_GET_INVITE, payload};
}

export function updateInvite(payload) {
  return {type: ACTIONS.CRYODEX_INVITE_UPDATE, payload}
}

//check if friendship exists
export function checkFriendship(payload){
  return {type: ACTIONS.CRYODEX_CHECK_FRIENDSHIP,payload}
}

//------
export function getFriends(payload) {
  return { type: ACTIONS.GET_FRIENDS, payload };
}

export function updateFriends(payload){
	return {type: ACTIONS.UPDATE_FRIENDS, payload};
}

export function getAllFriends(payload){
	return {type : ACTIONS.GET_ALL_FRIENDS,payload};
}


export function locationUser(payload){
 
  return { type: ACTIONS.CRYODEX_GET_LOCATION, payload };
}

export function getF(payload){ 
  return { type: ACTIONS.GET_GF, payload };
}

export function getFs(payload){ 
  return { type: ACTIONS.GET_GFS, payload };
}

export function getPlaces(payload){ 
  return { type: ACTIONS.GET_GPLACES, payload };
}

export function getAllFriendsGoingToMyLocation(payload){
	return {type:ACTIONS.GET_ALL_FRIENDS_GOING_TO_MY_LOCATION,payload};	
}

export function updateAllFriendsGoingToMyLocation(payload){
	return {type:ACTIONS.UPDATE_ALL_FRIENDS_GOING_TO_MY_LOCATION,payload};
}

